import Head from "next/head";

const WebSiteSchema = () => {
  return (
    <Head>
      <script
        id="WebsiteSchema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebSite",
            "@id": `${process.env.NEXT_PUBLIC_WEBSITE_URL}/#website`,
            name: "NewsTak",
            url: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/`,
            description:
              "NewsTak - Hindi news covering politics, education, crime, entertainment, and national news.",
            inLanguage: "hi-IN",
            potentialAction: {
              "@type": "SearchAction",
              target: `${process.env.NEXT_PUBLIC_WEBSITE_URL}/search/{search_term_string}`,
              "query-input": "required name=search_term_string",
            },
          }),
        }}
      />
    </Head>
  );
};

export default WebSiteSchema;
